// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import PipCode from '@deere/cps-it.warranty-model-factory/lib/pip-code';
import PipCodeRequestModalBody from './pip-code-request-modal-body';
import PipCodeRequestModalHeader from './pip-code-request-modal-header';
import TcsmApproveDenyModal from '../../state/tcsm-approve-deny-modal';
import {WarrantyMediumModal} from '../../../../shared/components/modal';

const PipCodeRequestModal = props =>
    <section className='pip-code-request-modal'>
        <WarrantyMediumModal isOpen={props.pipCodeRequestModal.isVisible}>
            <PipCodeRequestModalHeader
                closePipCodeRequestModal={props.closePipCodeRequestModal}
                pipCodeRequestModalAction={props.pipCodeRequestModal.actionToTake}
            />
            <PipCodeRequestModalBody
                onConfirmation={props.onConfirmation}
                onPipCodeTcsmCommentsChange={props.onPipCodeTcsmCommentsChange}
                pipCodeRequestItemToUpdate={props.pipCodeRequestItemToUpdate}
                pipCodeRequestModalAction={props.pipCodeRequestModal.actionToTake}
            />
        </WarrantyMediumModal>
    </section>;

PipCodeRequestModal.displayName = 'PipCodeRequestModal';
PipCodeRequestModal.propTypes = {
    closePipCodeRequestModal: PropTypes.func.isRequired,
    onConfirmation: PropTypes.func.isRequired,
    onPipCodeTcsmCommentsChange: PropTypes.func.isRequired,
    pipCodeRequestItemToUpdate: PropTypes.instanceOf(PipCode).isRequired,
    pipCodeRequestModal: PropTypes.instanceOf(TcsmApproveDenyModal).isRequired
};

export default PipCodeRequestModal;



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/pip-code-requests/pip-code-request-modal.js